export const zIndex = [-20, -10, 0, 10, 20, 30] as const;
